define('orderPicturesTabPictureItemView',[
  'module',
  'marionette',
  'template!orderPicturesTabPictureItemTpl',
  'bootbox',
  'jquery',
  'settings',
  'app',
  'underscore',
  'pluginUtils'
], function (
  module,
  Marionette,
  pictureItemTpl,
  bootbox,
  $,
  Settings,
  App,
  _,
  PluginUtils
) {
  'use strict';

  var PictureItemView = Marionette.ItemView.extend({
    template: pictureItemTpl,
    className: 'picture-elements',

    ui: {
      edit: '.js-edit',
      print: '.js-print',
      'delete': '.js-delete',
      hide: '.js-hidden',
      defaultVrp: '.js-default'
    },

    events: {
      'click @ui.edit': '_edit',
      'click @ui.print': '_print',
      'click @ui.delete': '_delete',
      'click @ui.hide': '_hideShowClick',
      'click @ui.defaultVrp': '_defaultVrpClick'
    },

    initialize: function () {
      if (this.model.collection) {
        this.listenTo(this.model.collection, 'vrp:default:changed', this.render);
      }
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      if (this.model.get('orderModel').get('defaultVrp') === this.model.get('secId')) {
        templateData.defaultVrp = true;
      } else {
        templateData.defaultVrp = false;
      }
      if (this.model.get('orderModel').get('hiddenVrps') &&
          this.model.get('orderModel').get('hiddenVrps').indexOf(this.model.get('secId')) !== -1) {
        templateData.hiddenVrp = true;
      } else {
        templateData.hiddenVrp = false;
      }
      return templateData;
    },

    _defaultVrpClick: function () {
      var orderModel = this.model.get('orderModel');
      var secId = this.model.get('secId');

      orderModel.setDefaultVrp(secId).done(_.bind(function () {
        orderModel.set('defaultVrp', secId, {silent: true});
        if (this.model.collection) {
          this.model.collection.trigger('vrp:default:changed');
        }
      }, this)).fail(function () {
        bootbox.alert(_.i18n('common.error'));
      });
    },

    _hideShowClick: function () {
      var orderModel = this.model.get('orderModel');
      var secId = this.model.get('secId');
      var hiddenVrps = orderModel.get('hiddenVrps') || [];
      var isHidden = hiddenVrps.indexOf(secId) !== -1;

      var request = isHidden ?
        orderModel.showVrp(secId) :
        orderModel.hideVrp(secId);

      request.done(_.bind(function () {
        var updated = (orderModel.get('hiddenVrps') || []).slice();
        if (isHidden) {
          updated = _.without(updated, secId);
        } else {
          updated.push(secId);
        }
        orderModel.set('hiddenVrps', updated, {silent: true});
        this.render();
      }, this)).fail(function () {
        bootbox.alert(_.i18n('common.error'));
      });
    },

    _edit: function () {
      PluginUtils.callPlugin({
        action: 'editProductPicture',
        productPictureSecId: this.model.get('secId')
      });
    },

    _print: function () {
      PluginUtils.callPlugin({
        action: 'placePrintArea',
        productPictureSecId: this.model.get('secId')
      });
    },

    _delete: function () {
      var model = this.model;
      bootbox.confirm(_.i18n('common.confirmDelete'), function (result) {
        if (result) {
          model.destroy();
        }
      });
    },

    _ambiance: function () {
      this.model.set('ambiance', !this.model.get('ambiance'));
      this.model.save().then(_.bind(function () {
        this.render();
      }, this));
    }
  });

  module.exports = PictureItemView;
});

